import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { AdminShell } from '../components/admin/AdminShell';
import { ContactsTable, TestimonialsTable } from '../components/admin/AdminTables';
import { adminApi, apiError } from '../lib/adminApi';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(null);
  const [tab, setTab] = useState('testimonials');
  const [testimonials, setTestimonials] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      const [t, c] = await Promise.all([adminApi.get('/admin/testimonials'), adminApi.get('/contacts')]);
      setTestimonials(t.data);
      setContacts(c.data);
    } catch (err) {
      if (err.response?.status === 401 || err.response?.status === 403) navigate('/admin/login');
      else setError(apiError(err));
    }
  }, [navigate]);

  useEffect(() => {
    adminApi.get('/auth/me')
      .then(({ data }) => { setAdmin(data); load(); })
      .catch(() => navigate('/admin/login'));
  }, [load, navigate]);

  const act = async (fn) => {
    setError('');
    try { await fn(); await load(); } catch (err) { setError(apiError(err)); }
  };
  const approve = (id) => act(() => adminApi.patch(`/admin/testimonials/${id}/approve`));
  const remove = (id) => window.confirm('¿Eliminar este testimonio definitivamente?')
    && act(() => adminApi.delete(`/admin/testimonials/${id}`));
  const logout = async () => { await adminApi.post('/auth/logout'); navigate('/admin/login'); };

  if (!admin) return <AdminShell title="Cargando..."><div data-testid="admin-loading" /></AdminShell>;

  const tabBtn = (key, label) => (
    <Button data-testid={`admin-tab-${key}`} variant={tab === key ? 'default' : 'outline'} onClick={() => setTab(key)}
      className={tab === key ? 'bg-kombu-green text-white' : 'border-tan text-cafe-noir'}>{label}</Button>
  );

  return (
    <AdminShell title="Panel de administración" wide>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div data-testid="admin-welcome" className="text-cafe-noir">Hola, <strong>{admin.name}</strong></div>
        <Button data-testid="admin-logout-btn" variant="outline" onClick={logout} className="border-tan">Cerrar sesión</Button>
      </div>
      <div className="flex gap-2 mb-6">
        {tabBtn('testimonials', `Testimonios (${testimonials.length})`)}
        {tabBtn('contacts', `Mensajes de contacto (${contacts.length})`)}
      </div>
      {error && <p data-testid="admin-error" className="text-sm text-red-700 mb-4">{error}</p>}
      {tab === 'testimonials'
        ? <TestimonialsTable items={testimonials} onApprove={approve} onDelete={remove} />
        : <ContactsTable items={contacts} />}
    </AdminShell>
  );
}
